export const STORE_LABEL = "Store";
export const STORE_NAME = "Store Name";
export const STORE_NAME_ACCESS_KEY = "store_name";
export const EDIT_STORE_LABEL = "Edit Store";
export const NEW_STORE_LABEL = "New Store";
